import { Box, Typography, Divider } from '@mui/material';

// Hero Components
import Hero from '../components/Hero';
import Hero2 from '../components/Hero2';
import HeroRevolution from '../components/HeroRevolution';
import ModernHero from '../components/ModernHero';

// Features Components
import Features from '../components/Features';
import Features2 from '../components/Features2';
import FeaturesRevolution from '../components/FeaturesRevolution';
import FeaturesMinimal from '../components/FeaturesMinimal';
import FeaturesElegant from '../components/FeaturesElegant';
import FeaturesRevamp from '../components/FeaturesRevamp';
import FeaturesPremium from '../components/FeaturesPremium';
import ModernFeatures from '../components/ModernFeatures';
import ModernFeatures2 from '../components/ModernFeatures2';
import FeaturesElegant2 from '../components/FeaturesElegant2';

// Platform Features Components
import PlatformFeatures from '../components/PlatformFeatures';
import PlatformFeatures2 from '../components/PlatformFeatures2';
import PlatformFeaturesClean from '../components/PlatformFeaturesClean';
import PlatformFeaturesModern from '../components/PlatformFeaturesModern';
import PlatformFeaturesPremium from '../components/PlatformFeaturesPremium';

// Showcase Components
import MobileShowcase from '../components/MobileShowcase';
import MobileShowcaseExact from '../components/MobileShowcaseExact';
import MobileShowcasePerfect from '../components/MobileShowcasePerfect';
import ModernShowcase from '../components/ModernShowcase';
import ModuleShowcase from '../components/ModuleShowcase';

// Other Components
import HowItWorks from '../components/HowItWorks';
import Testimonials from '../components/Testimonials';
import ModernTestimonials from '../components/ModernTestimonials';
import CTA from '../components/CTA';
import ModernStats from '../components/ModernStats';
import ModernPricing from '../components/ModernPricing';
import Mobile from '../components/Mobile';



const Home = () => {
  return (
    <Box>
      <Hero />
      <FeaturesElegant />
      <Features />
      <ModernFeatures2 />
      <ModernFeatures />
      {/* <MobileShowcasePerfect /> */}
      <Mobile />
      <HowItWorks />
      
    </Box>
  );
};

export default Home;